@use '../@shared/global' as *;
@use '../@shared/alert.mixin' as *;

@layer kol-component {
	@include kol-alert;
}
